import { Gauge } from "lucide-react";
import { modelLabel, primaryLimited } from "@/lib/models";
import type { AgentWithContext } from "@/lib/types";
import { cn } from "@/lib/utils";

const TINT = "var(--prio-high)";

const clock = (iso: string) => new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

/**
 * "on Opus 5.5 (Fable limit)": the agent's model is at its usage limit and its turns
 * run on the fallback until the reset. Nothing at all otherwise, so an agent without
 * a fallback looks as it always did. `compact` drops the reason, for a list row.
 */
export function FallbackPill({ agent, now, compact = false, className }: { agent: AgentWithContext; now: number; compact?: boolean; className?: string }) {
  if (!primaryLimited(agent, now)) return null;
  const fallback = modelLabel(agent.fallbackModel!);
  const primary = agent.model ? modelLabel(agent.model) : "Model";
  const until = clock(agent.primaryLimitedUntil!);
  return (
    <span
      title={`${primary} hit its usage limit; turns run on ${fallback} until it resets at ${until}.`}
      className={cn("inline-flex shrink-0 items-center gap-1 rounded-full px-1.5 py-px text-[10.5px] font-medium leading-4", className)}
      style={{ color: TINT, backgroundColor: `color-mix(in oklab, ${TINT} 16%, transparent)` }}
    >
      <Gauge className="size-3" aria-hidden />
      {compact ? `on ${fallback}` : `on ${fallback} (${primary} limit)`}
    </span>
  );
}
